let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("17Qwb"), load("dWaws"), load("cwcoO")]).then(() => parcelRequire('1wfzY'));